
export const plexosConstants = {
  UPLOAD_PLEXOS_CONFIG: 'UPLOAD_PLEXOS_CONFIG',
  UPLOAD_PLEXOS_CONFIG_SUCCESS: 'UPLOAD_PLEXOS_CONFIG_SUCCESS',
  UPLOAD_PLEXOS_CONFIG_ERROR: 'UPLOAD_PLEXOS_CONFIG_ERROR',
  FETCH_CURRENT_CONFIG: 'FETCH_CURRENT_CONFIG',
  FETCH_CURRENT_CONFIG_SUCCESS: 'FETCH_CURRENT_CONFIG_SUCCESS',
  FETCH_CURRENT_CONFIG_ERROR: 'FETCH_CURRENT_CONFIG_ERROR'
}
